/* eslint-disable react/prop-types */
import studioStore from '@/stores/studioStore';

const VariationSelect = ({ product, selectedVariation, handleVariationChange, t, layout = "normal" }) => {
  let classes = " px-2 py-1";
  let designClases = "bg-white/75 border border-white text-gray-900";
  let style = { color: `${studioStore?.settings?.colors?.primary_color}` };
  if (layout === "compact") {
    classes = " me-2";
    designClases = "bg-gray-200 border border-gray-500 text-gray-900";
    style = {};
  }
  return (
    <div className={`variation-selector${classes}`}>
      <select
        id={`variation-${product.id}`}
        onChange={handleVariationChange}
        value={selectedVariation?.id || ''}
        className={`${designClases} text-sm font-medium rounded-xl transition-all p-1`}
        style={style}
      >
        <option value="" disabled>{t('select_variation')}</option>
        {product.variations
          .filter(variation => variation.status === 'publish') // Filter by status
          .map(variation => (
            <option key={variation.id} value={variation.id}>
              {variation.attributes.map(attr => decodeURIComponent(attr.option)).join(' / ')}
            </option>
          ))}
      </select>
    </div>
  );
};

export default VariationSelect;
